<template>
  <div>
    <logging ref="logs" />
    <files ref="files" />
    <publicFiles ref="publicFiles" />
    <adding ref="add" />
    <modify ref="mod" />
    <attach ref="addport" />
    <message ref="msg" />
    <importing ref="importing" />

    <modalWindow v-if="modifyAdvisorModal" @close="modifyAdvisorModal = false" width="700">
      <div class="titlebar">Adviseur details</div>
      <div class="flex-container flex-grow card inset">
        <div class="flex-100 subheader">Adviseur gegevens</div>
        <div class="flex-33">
          <customInput
            ref="focus"
            v-model="atp.advisorName"
            type="text"
            label="Naam*"
          />
        </div>
        <div class="flex-33">
          <customInput
            ref="focus"
            v-model="atp.advisorInfix"
            type="text"
            label="Tussenvoegsel"
            :validation="['notrequired']"
          />
        </div>
        <div class="flex-33">
          <customInput
            ref="focus"
            v-model="atp.advisorSurname"
            type="text"
            label="Achternaam*"
          />
        </div>

        <div class="flex-100 subheader">Kantoor gegevens</div>
        <customInput
          class="flex-50"
          ref="focus"
          v-model="atp.name"
          type="text"
          label="Naam*"
        />
        <customInput
          class="flex-50"
          ref="focus"
          v-model="atp.website"
          type="text"
          label="Website*"
        />
        <customInput
          class="flex-33"
          ref="focus"
          v-model="atp.street"
          type="text"
          label="Straat*"
        />
        <customInput
          class="flex-33"
          ref="focus"
          v-model="atp.housenr"
          type="text"
          label="Huisnummer*"
        />
        <customInput
          class="flex-33"
          ref="focus"
          v-model="atp.housenrAddition"
          type="text"
          label="Toevoeging"
          :validation="['notrequired']"
        />
        <customInput
          class="flex-50"
          ref="focus"
          v-model="atp.postal"
          type="text"
          placeholder="1111AA"
          label="Postcode*"
        />
        <customInput
          class="flex-50"
          ref="focus"
          v-model="atp.city"
          type="text"
          label="Plaatsnaam*"
        />
        <customInput
          class="flex-50"
          ref="focus"
          v-model="atp.phone"
          type="text"
          label="Telefoonnummer*"
        />
        <customInput
          class="flex-50"
          ref="focus"
          v-model="atp.email"
          type="text"
          label="E-mailadres*"
          :validation="[ 'email']"
        />
        <customInput
          class="flex-100"
          ref="focus"
          v-model="atp.iban"
          type="text"
          label="Rekeningnummer (IBAN)"
          :validation="['notrequired','iban']"
        />
        <!-- KVK-nummer -->
        <customInput
          class="flex-100"
          ref="focus"
          v-model="atp.kvk"
          type="text"
          label="KVK-nummer"
          :validation="['notrequired']"
        />
        <!-- Fee -->
        <customInput
          class="flex-33"
          ref="focus"
          v-model="atp.fee"
          type="dropdown"
          :options="feeoptions"
          label="Standaard fee"
          :validation="['notrequired']"
        />
        <!-- Aantal adviseurs -->
        <customInput
          class="flex-33"
          ref="focus"
          v-model="atp.totalAdvisors"
          type="dropdown"
          :options="[
            {label:'0-5', value:'0-5'},
            {label:'5-10', value:'5-10'},
            {label:'10+', value:'10+'},
          ]"
          label="Aantal adviseurs"
          :validation="['notrequired']"
        />
        <!-- Aantal klanten -->
        <customInput
          class="flex-33"
          ref="focus"
          v-model="atp.customers"
          type="dropdown"
          :options="[
            {label:'0-500', value:'0-500'},
            {label:'500-1000', value:'500-1000'},
            {label:'1000+', value:'1000+'},
          ]"
          label="Aantal klanten"
          :validation="['notrequired']"
        />
        <div class="flex 33" style="margin-top: 10px">
          <button title="opslaan" @click="updateAtpDetails(selected)" style="float:right">
            Opslaan
          </button>
        </div>
      </div>
    </modalWindow>

    <tableFilter
      name="usersFilters"
      ref="filterComp"
      :activeAmount="activeFilters"
      :mainFunction="getUsers"
      v-model="filters"
    />

    <div class="card" v-if="users !== null && users.length > 0">
      <table>
        <thead class="table-legend">
          <tr>
            <th width="10%">ID</th>
            <th>Naam</th>
            <th width="15%">Gebruikersnaam</th>
            <th>E-mailadres</th>
            <th width="10%">Rol</th>
          </tr>
        </thead>
        <tr
          v-for="user in users"
          :key="user.id" @mouseover="selected = user.id"
        >
          <td>{{user.id}}</td>
          <td class="concat" :title="user.name">{{user.name}}</td>
          <td class="concat">{{user.username}}</td>
          <td class="concat" v-if="user.id !== selected">{{user.email}}</td>
          <td v-if="user.id !== selected">{{user.roleText}}</td>
          <td
            v-if="user.id === selected || portDropdown[user.id] || optionsDropdown[user.id]"
            colspan=2 class="dropdown-wrapper"
          >
            <div class="dropdown nowrap">
              <button
                class="dropdown-button secondary"
                @click="portDropdown[user.id] = !portDropdown[user.id]"
              >
                <awesomeIcon icon="wallet" /> Portefeuille opties
              </button>
              <div
                class="dropdown-bg"
                v-if="portDropdown[user.id]"
                @click="portDropdown[user.id] = !portDropdown[user.id]"
              ></div>
              <div class="dropdown-list" v-if="portDropdown[user.id]">
                <li
                  style="border-bottom:1px solid #dcdcdc;" v-if="$store.state.role > 8"
                  @click="
                    portDropdown[user.id] = !portDropdown[user.id];
                    doAction('userPort', user.id);
                  "
                >
                  <awesomeIcon icon="plus"/> Portefeuille toevoegen
                </li>
                <ul class="list">
                  <template v-if="$store.state.role > 8">
                    <li
                      v-for="(port, index) in user.ports"
                      :key="`a-${user.id}-${index}`"
                      @click="removeUserPort(user.id, port.id)"
                    >
                      {{port.id}}
                      <awesomeIcon
                        class="red" icon="trash-alt" style="float:right;margin-left:5px;"
                      />
                    </li>
                  </template>
                  <template v-else>
                    <li
                      v-for="(port, index) in user.ports" :key="`m-${user.id}-${index}`"
                      @click="portDropdown[user.id] = !portDropdown[user.id]"
                    >{{port.id}}</li>
                  </template>
                </ul>
                <div
                  class="dropdown-cancel"
                  @click="portDropdown[user.id] = !portDropdown[user.id]"
                >
                  Annuleren
                </div>
              </div>
            </div>
            <div class="dropdown nowrap">
              <button
                class="dropdown-button secondary"
                @click="optionsDropdown[user.id] = !optionsDropdown[user.id]"
              >
                <awesomeIcon icon="cog" /> Gebruiker opties
              </button>
              <div
                class="dropdown-bg" v-if="optionsDropdown[user.id]"
                @click="optionsDropdown[user.id] =!optionsDropdown[user.id]"
              ></div>
              <ul class="dropdown-list" v-if="optionsDropdown[user.id]">
                <li
                  @click="
                    optionsDropdown[user.id] = !optionsDropdown[user.id];
                    doAction('userPassword', user.id);
                  "
                >
                  <awesomeIcon icon="key"/> Wachtwoord herstellink sturen
                </li>
                <li
                  @click="
                    optionsDropdown[user.id] = !optionsDropdown[user.id];
                    doAction('remove2fa', user.id);
                  "
                >
                  <awesomeIcon icon="lock-open"/> Verwijder 2FA
                </li>
                <li
                  @click="
                    optionsDropdown[user.id] = !optionsDropdown[user.id];
                    doAction('userMessage', user.id);
                  "
                >
                  <awesomeIcon icon="envelope"/> Bericht sturen
                </li>
                <li
                  v-if="$store.state.role > 7 && $store.state.role > user.role"
                  @click="
                    optionsDropdown[user.id] = !optionsDropdown[user.id];
                    doAction('becomeUser', user.id);
                  "
                >
                  <awesomeIcon icon="eye"/> Bekijk gebruiker
                </li>
                <li
                  @click="
                    optionsDropdown[user.id] = !optionsDropdown[user.id];
                    doAction('crm', user.id);
                  "
                >
                  <awesomeIcon icon="level-up-alt"/> Open in CRM
                </li>
                <li
                  @click="
                    optionsDropdown[user.id] = !optionsDropdown[user.id];
                    doAction('userLogs', user.id, user.name);
                  "
                >
                  <awesomeIcon icon="calendar"/> Activiteiten log
                </li>
                <li
                  @click="
                    optionsDropdown[user.id] = !optionsDropdown[user.id];
                    doAction('userFiles', user.id);
                  "
                >
                  <awesomeIcon icon="file"/> Bestanden
                </li>
                <li
                  @click="
                    optionsDropdown[user.id] = !optionsDropdown[user.id];
                    doAction('getUserPublicFiles', user.id);
                  "
                >
                  <awesomeIcon icon="file"/> Publieke bestanden
                </li>
                <li
                  v-if="$store.state.role > 8 && $store.state.role >= user.role"
                  @click="
                    optionsDropdown[user.id] = !optionsDropdown[user.id];
                    doAction('modifyUser', user.id);
                  "
                >
                  <awesomeIcon icon="cog"/> Aanpassen
                </li>
                <li
                  v-if="$store.state.role > 8 && user.role === 2"
                  @click="
                    optionsDropdown[user.id] = !optionsDropdown[user.id];
                    doAction('modifyAdvisor', user.id);
                  "
                >
                  <awesomeIcon icon="cog"/> Adviseur aanpassen
                </li>
                <li
                  v-if="$store.state.role > 8 && $store.state.role >= user.role"
                  @click="
                    optionsDropdown[user.id] = !optionsDropdown[user.id];
                    doAction('deleteUser', user.id);
                  "
                >
                   <awesomeIcon icon="user-slash"/> Verwijder
                </li>
                <li
                  class="dropdown-cancel"
                  @click="optionsDropdown[user.id] = !optionsDropdown[user.id]"
                >
                  Annuleren
                </li>
              </ul>
            </div>
          </td>
        </tr>
      </table>
      <pagerElement
        v-model="currentPage"
        :records="totalUsers"
        :resultsPerPage="maxPerPage"
      />
    </div>
    <div class="noresults" v-else-if="users !== null">
      <span>Geen resultaten</span>
    </div>
    <div v-else class="loader"/>
  </div>
</template>

<script>
import adding from './admin/adding';
import attach from './admin/attach';
import importing from './admin/import';
import files from './admin/files';
import publicFiles from './admin/publicFiles';
import logging from './admin/logging';
import message from './admin/message';
import modify from './admin/modify';

export default {
  name: 'AdminUsers',
  components: {
    adding,
    attach,
    files,
    publicFiles,
    logging,
    message,
    modify,
    importing,
  },
  data() {
    return {
      selected: null,
      users: null,
      currentPage: 0,
      maxPerPage: 20,
      totalUsers: 0,
      atp: {
        city: null,
        fee: null,
        name: null,
        street: null,
        housenr: null,
        housenrAddition: null,
        postal: null,
        website: null,
        phone: null,
        iban: null,
        email: null,
        advisorName: null,
        advisorInfix: null,
        advisorSurname: null,
        totalAdvisors: null,
        customers: null,
        kvk: null,
      },
      modifyAdvisorModal: false,
      feeoptions: [
        { label: 'DB ATP 10%', value: 'dbatp' },
        { label: 'DB ATP all-in (opb)', value: 'dbatpopbouwend' },
        { label: 'DB ATP all-in (uit)', value: 'dbatpuitkerend' },
      ],
      portDropdown: {},
      optionsDropdown: {},
      activeFilters: [],
      filters: [
        {
          name: 'generalInput',
          model: '',
          cookie: 'usersGeneralInput',
          filterName: 'search',
          operator: 'contains',
          operators: ['eq', 'neq', 'contains', 'startswith', 'endswith'],
          title: 'ID, Naam, Gebruikersnaam, E-mail adres, Portefeuille nummer',
        },
        {
          name: 'newUserButton',
          label: 'Nieuwe gebruiker',
          type: 'button',
          position: 'topbar',
          icon: 'user-plus',
          requirements: this.$store.state.role > 8,
          cb: () => {
            this.$refs.add.adding = true;
          },
        },
        {
          name: 'importButton',
          label: 'Importeer',
          type: 'button',
          position: 'topbar',
          icon: 'user-plus',
          requirements: this.$store.state.role > 8,
          cb: () => {
            this.$refs.importing.importing = true;
          },
        },
        {
          name: 'groupMessageButton',
          label: 'Groepsbericht',
          type: 'button',
          position: 'topbar',
          icon: 'envelope',
          requirements: this.$store.state.role > 8,
          cb: () => {
            this.$refs.msg.userMessage('');
          },
        },
        {
          name: 'userIdInput',
          label: 'ID',
          type: 'number',
          cookie: 'usersUserIdInput',
          model: '',
          filterName: 'id',
          operator: 'eq',
          operators: ['eq', 'neq', 'gt', 'lt'],
        },
        {
          name: 'nameInput',
          label: 'Naam',
          type: 'text',
          cookie: 'usersNameInput',
          model: '',
          filterName: 'name',
          operator: 'contains',
          operators: ['eq', 'neq', 'startswith', 'endswith', 'contains'],
        },
        {
          name: 'usernameInput',
          label: 'Gebruikersnaam',
          type: 'text',
          cookie: 'usersUsernameInput',
          model: '',
          filterName: 'username',
          operator: 'contains',
          operators: ['eq', 'neq', 'startswith', 'endswith', 'contains'],
        },
        {
          name: 'emailInput',
          label: 'E-mail adres',
          type: 'text',
          cookie: 'usersEmailInput',
          model: '',
          filterName: 'email',
          operator: 'contains',
          operators: ['eq', 'neq', 'startswith', 'endswith', 'contains'],
        },
        {
          name: 'portInput',
          label: 'Portefeuille ID',
          type: 'text',
          cookie: 'usersPortInput',
          model: '',
          filterName: 'port',
          operator: 'contains',
          operators: ['eq', 'neq', 'startswith', 'endswith', 'contains'],
        },
        {
          name: 'roleInput',
          type: 'multiDropdown',
          cookie: 'usersRoleInput',
          filterName: 'role',
          model: '',
          operator: 'in',
          attributes: [
            {
              name: 'array',
              value: [
                {
                  label: '-1: Lead',
                  value: -1,
                },
                {
                  label: '0: Gebruiker',
                  value: 0,
                },
                {
                  label: '2: Adviseur +',
                  value: 2,
                },
                {
                  label: '8: Beheerder',
                  value: 8,
                },
                {
                  label: '9: Admin',
                  value: 9,
                },
                {
                  label: '10: Superadmin',
                  value: 10,
                },
              ],
            },
            {
              name: 'displayPrefix',
              value: 'Rol',
            },
            {
              name: 'clearedDisplayValue',
              value: 'Alle',
            },
          ],
        },
      ],
    };
  },
  watch: {
    currentPage() {
      this.$refs.filterComp.get();
    },
  },
  methods: {
    getAtpDetailsForUser(advisor) {
      this.sdk.getAtpDetailsForUser(
        advisor,
        (response) => {
          if (response.status === 200 && response.data.length > 0) {
            this.atp = {
              city: response.data[0].city,
              name: response.data[0].name,
              street: response.data[0].street,
              housenr: response.data[0].housenr,
              housenrAddition: response.data[0].housenr_addition,
              postal: response.data[0].postal,
              website: response.data[0].website,
              phone: response.data[0].phone,
              iban: response.data[0].iban,
              email: response.data[0].email,
              advisorName: response.data[0].advisor_name,
              advisorInfix: response.data[0].advisor_infix,
              advisorSurname: response.data[0].advisor_surname,
              totalAdvisors: response.data[0].total_advisors,
              customers: response.data[0].customers,
              kvk: response.data[0].kvk,
              fee: response.data[0].fee,
            };
          }
        },
      );
    },
    updateAtpDetails(advisor) {
      if (!this.atp.city
        || !this.atp.name
        || !this.atp.email
        || !this.atp.phone
        || !this.atp.website
        || !this.atp.postal
        || !this.atp.housenr
        || !this.atp.street
        || !this.atp.advisorName
        || !this.atp.advisorSurname
      ) {
        this.$store.state.confirm.toggle({
          alert: true,
          text: 'Niet alle verplichte velden zijn ingevuld',
          cb: () => {},
        });
        return;
      }
      if (this.atp.email) {
        const re = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/g;
        if (!re.test(this.atp.email)) {
          this.$store.state.confirm.toggle({
            alert: true,
            text: 'Dit is een onjuist e-mailadres',
            cb: () => {},
          });
          return;
        }
      }
      if (this.atp.iban) {
        if (!this.checkIban(this.atp.iban)) {
          this.$store.state.confirm.toggle({
            alert: true,
            text: 'Dit is een onjuist IBAN',
            cb: () => {},
          });
          return;
        }
      }
      this.sdk.updateAdminAtpDetails(
        advisor,
        (response) => {
          if (response.status === 200) {
            this.$store.state.confirm.toggle({
              alert: true,
              text: 'Gegevens succesvol opgeslagen',
              cb: () => {},
            });
            this.getAtpDetailsForUser(advisor);
            this.modifyAdvisorModal = false;
          }
        },
        this.atp.city,
        this.atp.name,
        this.atp.street,
        this.atp.housenr,
        this.atp.housenrAddition,
        this.atp.postal,
        this.atp.iban || '',
        this.atp.website,
        this.atp.phone,
        this.atp.email,
        this.atp.advisorName,
        this.atp.advisorInfix,
        this.atp.advisorSurname,
        this.atp.totalAdvisors,
        this.atp.customers,
        this.atp.kvk,
        this.atp.fee,
      );
    },
    checkIban(iban) {
      let sum = String(iban);
      sum = sum.replace(/ /gi, '');
      sum = sum.replace(' ', '');
      if (sum.length < 15) {
        return false;
      }

      sum = sum.slice(4) + sum.slice(0, 4);
      const letters = {
        a: 10,
        b: 11,
        c: 12,
        d: 13,
        e: 14,
        f: 15,
        g: 16,
        h: 17,
        i: 18,
        j: 19,
        k: 20,
        l: 21,
        m: 22,
        n: 23,
        o: 24,
        p: 25,
        q: 26,
        r: 27,
        s: 28,
        t: 29,
        u: 30,
        v: 31,
        w: 32,
        x: 33,
        y: 34,
        z: 35,
      };
      // eslint-disable-next-line
      for (const [key, value] of Object.entries(letters)) {
        sum = sum.replace(new RegExp(key, 'gi'), value);
      }

      // eslint-disable-next-line
      function iso7064Mod97_10(iban) {
        let remainder = iban;
        let block;

        while (remainder.length > 2) {
          block = remainder.slice(0, 9);
          remainder = (parseInt(block, 10) % 97) + remainder.slice(block.length);
        }
        return parseInt(remainder, 10) % 97;
      }

      sum = iso7064Mod97_10(sum);
      return sum === 1;
    },
    getRole(roleIndex) {
      switch (roleIndex) {
        case -1:
          return 'Lead';
        case 0:
          return 'Gebruiker';
        case 2:
          return 'Adviseur +';
        case 8:
          return 'Beheerder';
        case 9:
          return 'Admin';
        case 10:
          return 'Superadmin';
        default:
          return null;
      }
    },
    doAction(action, user, name) {
      if (action === 'userPort') {
        this.$refs.addport.userPort(user);
      } else if (action === 'userPassword') {
        this.userPassword(user);
      } else if (action === 'userMessage') {
        this.$refs.msg.userMessage(user);
      } else if (action === 'becomeUser') {
        this.becomeUser(user);
      } else if (action === 'modifyUser') {
        this.$refs.mod.userModify(user);
      } else if (action === 'modifyAdvisor') {
        this.getAtpDetailsForUser(user);
        this.modifyAdvisorModal = true;
      } else if (action === 'deleteUser') {
        this.deleteUser(user);
      } else if (action === 'remove2fa') {
        this.remove2fa(user);
      } else if (action === 'userLogs') {
        this.$refs.logs.userLogs(user, name);
      } else if (action === 'userFiles') {
        this.$refs.files.userFiles(user);
      } else if (action === 'getUserPublicFiles') {
        this.$refs.publicFiles.getUserPublicFiles(user);
      } else if (action === 'crm') {
        this.sdk.getUserCRM(user, (response) => {
          if (response.status === 200) {
            window.open(
              `https://vmvb.crm4.dynamics.com/main.aspx?forceUCI=1&pagetype=entityrecord&etn=contact&id=${response.data.id}`,
              '_blank',
            );
          } else {
            // eslint-disable-next-line
            alert('Client niet gevonden in Dynamics.');
          }
        });
      }
    },
    getUsers(newSearch, filter = '', activeFilters = []) {
      this.users = null;
      this.activeFilters = activeFilters;

      if (this.activeFilters.length) {
        this.$refs.filterComp.toggle(true);
      }
      if (filter.length) {
        filter = filter.join(';');
      }

      if (newSearch) {
        this.currentPage = 0;
      }

      this.sdk.getUsers((response) => {
        if (response.status === 200) {
          for (let i = 0; i < response.data.results.length; i += 1) {
            response.data.results[i].roleText = this.getRole(response.data.results[i].role);
          }
          this.users = response.data.results;
          this.totalUsers = response.data.totalRows;
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      }, filter, this.currentPage, this.maxPerPage);
    },
    removeUserPort(user, port) {
      this.$store.state.confirm.toggle({
        text: 'Weet u zeker dat u deze portefeuille wilt ontkoppelen voor deze gebruiker?',
        cb: (confirmed) => {
          if (confirmed) {
            this.sdk.removeUserPort(user, port, (response) => {
              if (response.status === 200) {
                this.getUsers(true);
              }
            });
          }
        },
      });
    },
    remove2fa(user) {
      this.$store.state.confirm.toggle({
        text: 'Weet u zeker dat u twee staps verificatie voor deze gebruiker wilt verwijderen?',
        confirmText: 'Verwijderen',
        cancelText: '',
        cb: (confirmed) => {
          if (confirmed) {
            this.sdk.adminRemove2fa(user, () => { });
          }
        },
      });
    },
    userPassword(user) {
      let style = 'Velthuyse Mulder';
      if (process.env.VUE_APP_STYLE === 'ox') {
        style = 'OXBY';
      } else if (process.env.VUE_APP_STYLE === 'bvs') {
        style = 'Beer Van Stapele';
      } else if (process.env.VUE_APP_STYLE === 'db') {
        style = 'Doelbeleggen';
      }

      this.$store.state.confirm.toggle({
        text: `Wachtwoord sturen? Let op: u gaat vanuit ${style} mailen, klopt dit?`,
        cb: (confirmed) => {
          if (confirmed) {
            this.sdk.sendUserPassword(user, () => { });
          }
        },
      });
    },
    deleteUser(user) {
      this.$store.state.confirm.toggle({
        text: 'Weet u zeker dat u deze gebruiker wilt verwijderen?',
        confirmText: 'Verwijderen',
        cb: (confirmed) => {
          if (confirmed) {
            this.sdk.deleteUser(user, (response) => {
              if (response.status === 200) {
                this.getUsers(true);
              }
            });
          }
        },
      });
    },
    becomeUser(user) {
      this.sdk.become(user, (response) => {
        if (response.status === 200) {
          window.location.reload();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  table {
    table-layout:fixed;
  }
  .dropdown-wrapper {
    padding: 0;
  }
  .dropdown-button {
    border-radius: 0;
  }
  .dropdown {
    border: none;
    float: right;
    padding-left: 10px;
    padding-right: 10px;
  }
  .main-menubar {
    padding: 2px;
    box-sizing: border-box;
    border-radius: 0;
    display: flex;
    justify-content: space-between;
  }
  .searchbar {
    flex: 1;
    float: left;
    margin: 0 2px !important;
    height: 36px;
  }
  .filter-button {
    float: left;
  }
  .noresults {
    width: 100%;
    height: auto;
    padding: 100px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      font-size: 20px;
    }
  }
</style>
